import {useMaterialUIController} from "../../../../Context/mui";
import MDBox from "../../../MDBox";
import {CircularProgress, Grid, Skeleton} from "@mui/material";
import {useEffect, useRef} from "react";
import MDTypography from "../../../MDTypography";

export default function Loading({children}) {
    const [controller, dispatch] = useMaterialUIController();
    const {loading} = controller;

    const ref = useRef();
    return <>
        {loading && <MDBox
            sx={{
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100vh",
                background: "#1A4C52",
                zIndex: 99999999,
                opacity: "0.7"
            }}>
            <Grid container>
                <Grid item justifyContent={"center"} height={"100vh"} alignContent={"center"} container>
                    <CircularProgress size={150} color="secondary"/>
                    <MDTypography textAlign={"center"} sx={{width: "100%"}} mt={4} fontWeight={"bold"} fontSize={"2rem"}
                                  color={"white"}>لطفا منتظر بمانید </MDTypography>
                </Grid>

            </Grid>

        </MDBox>}
        {children}
    </>
}